import './index.css'
import CustomPopup from "../../components/CustomPopup";
import React, {useContext, useState} from "react";
import DailyPage from "./component/daily/DailyPage.tsx";
import RecordPage from "./component/record/record.tsx";
import {ThemeContext} from "../../providers/themeContext/theme-context.tsx";
import ChallengeRanking from "./component/challenge/challenge.tsx";
import './index.css'
import {useUserContext} from "../../providers/userProvider/user-context.tsx";
import CountrySelectionDialog from "../home/component/countrySelectDialog/CountrySelectionDialog.tsx";
import CustomProfile from "../../components/CustomProfile/CustomProfile.tsx";

type LeaderboardProps = {
    isOpen: boolean;
    onClose: () => void;
};

// 排行榜页面
const Leaderboard: React.FC<LeaderboardProps> = ({isOpen, onClose}) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    // 全局用户信息provider
    const {user} = useUserContext();
    // 切换页面的按钮状态 1是daily，2challenge，3是Record
    const [switchIndex, setSwitchIndex] = React.useState<number>(1);
    // 国别排行切换按钮 1是全部，2是本国
    const [countryRankingIndex, setCountryRankingIndex] = React.useState<number>(1);
    // 是否显示国家选择弹窗
    const [isShowCountryDialog, handleCloseCountryDialog] = React.useState<boolean>(false);
    // 是否显示对方用户弹窗
    const [showOtherPlayerProfile, setShowOtherPlayerProfile] = useState<boolean>(false)
    // 对方用户id
    const [otherUserId, setOtherUserId] = useState<string | null>(null)

    // 暂时废弃，在各个页面自行触发埋点
    // useEffect(() => {
    //     if (isOpen) {
    //         // GA埋点
    //         const page = switchIndex === 1 ? 'Daily' : switchIndex === 2 ? 'Challenge_leadboard' : 'Record';
    //
    //         GAEvents.leaderboardPageShow(page)
    //     }
    // }, [switchIndex, isOpen]);

    // 切换方法
    const switchPage = (index: number) => {
        setSwitchIndex(index)
    }

    // 打开国家选择弹窗
    const openCountryDialog = () => {
        handleCloseCountryDialog(true);
    }

    // 打开对方的用户信息页
    const openOpponentUserInfoPage = (userId: string) => {
        setOtherUserId(userId)
        setShowOtherPlayerProfile(true)
    }

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="leader-board-page">
                <img className="leaderboard-background-img" src={imgUrls.leaderboardBgPicUrl} alt="img"/>
                <div className="leader-board-header">
                    <div className="leader-board-title my-roboto-medium">Leaderboards</div>
                    <img onClick={onClose} className="leader-board-close-btn" src={imgUrls.closeBtnWhiteUrl}
                         alt="close"/>
                </div>
                <div
                    className={`leader-board-switch-btn-container ${switchIndex === 1 || switchIndex === 2 ? "border-top-radius-6" : "border-radius-6"} `}>
                    <div onClick={() => switchPage(1)}
                         className={`leader-board-switch-btn my-roboto-medium ${switchIndex === 1 ? 'leader-board-selected border-left-top-radius-6' : ''}`}>Daily
                    </div>
                    <div onClick={() => switchPage(2)}
                         className={`leader-board-switch-btn my-roboto-medium ${switchIndex === 2 ? 'leader-board-selected' : ''}`}>Challenge
                    </div>
                    <div onClick={() => switchPage(3)}
                         className={`leader-board-switch-btn my-roboto-medium ${switchIndex === 3 ? 'leader-board-selected border-right-radius-6' : ''}`}>Record
                    </div>
                </div>
                {switchIndex === 3 ? undefined :
                    <div className="leader-board-switch-btn-country-rank">
                        <div onClick={() => setCountryRankingIndex(1)}
                             className={`${countryRankingIndex === 1 ? 'color-blue' : 'color-grey'} font-size-13 my-roboto-medium width-136 display-flex-row display-flex-align-items-center display-flex-justify-content-center`}>
                            <div
                                className={`margin-right-3 ${countryRankingIndex === 1 ? 'leader-board-country-switch-btn-selected' : 'leader-board-country-switch-btn-unselected'}`}/>
                            Global Rank
                        </div>

                        {user?.country ? <div onClick={() => setCountryRankingIndex(2)}
                                              className={`${countryRankingIndex === 2 ? 'color-blue' : 'color-grey'} font-size-13 my-roboto-medium width-136 display-flex-row display-flex-align-items-center display-flex-justify-content-center`}>
                                <div
                                    className={`margin-right-3 ${countryRankingIndex === 2 ? 'leader-board-country-switch-btn-selected' : 'leader-board-country-switch-btn-unselected'}`}/>
                                <div>{user.country}</div>
                            </div>
                            :
                            <div onClick={openCountryDialog}
                                className="color-blue font-size-13 my-roboto-medium width-136 display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                                <div className="max-width-290 margin-left-8 text-ellipsis ">
                                    Country/Region
                                </div>
                                <div className="width-21 margin-left-3">{`>`}</div>
                            </div>
                        }
                    </div>}
                {/*根据switchIndex的数字显示不同的页面*/}
                {switchIndex === 1 ? (
                    <DailyPage isOpen={isOpen} countryRankingIndex={countryRankingIndex} openOpponentUserInfoPage={openOpponentUserInfoPage}/>
                ) : undefined}
                {switchIndex === 2 && (
                    <ChallengeRanking countryRankingIndex={countryRankingIndex}  isOpen={isOpen} openOpponentUserInfoPage={openOpponentUserInfoPage}/>
                )}
                {switchIndex === 3 && (
                    <RecordPage isOpen={isOpen}/>
                )}
            </div>
            <CountrySelectionDialog isOpen={isShowCountryDialog} onClose={() => handleCloseCountryDialog(false)}/>
            <CustomProfile isOpen={showOtherPlayerProfile} onClose={() => setShowOtherPlayerProfile(false)}
                           userId={otherUserId}/>
        </CustomPopup>
    );
};

export default Leaderboard;